import * as React from 'react';
import { Prompt } from 'react-router';
import { Card } from 'material-ui/Card';
import { get } from 'lodash';
import { Divider } from 'material-ui';
import { compose, withProps } from 'recompose';
import { reduxForm } from 'redux-form';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';

import { Tabs } from '@components/tabs';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';

import * as T from '@modules/jobs/_jobsTypes';
import { getJob } from '@modules/jobs/_jobsActions';
import { JobsFormBasic } from '@modules/jobs/JobsFormBasic';
import { JobRunsGrid } from '@modules/jobs/JobRunsGrid';

const linkBack = '/jobs';

const enhance = compose<T.JobsFormProps, T.JobsFormProps>(
  EntityDetailEnhancer<T.JobsEnhancerProps<T.Job>, T.Job>({
    getEntity: getJob,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [{ label: 'Notifikace', to: linkBack }, { label: get(entity, 'name', 'Nový plán') }]),
  withProps<{}, T.JobsForm>(({ entity }) => ({
    initialValues: get(entity, 'id') ? entity : {}
  })),
  reduxForm({})
);
const View: React.SFC<any> = ({ change, closeItem, dirty, submitSucceeded, submitting, handleSubmit, item }) => (
  <div>
    <Prompt when={dirty && !submitSucceeded && !submitting} message="Vaše změny nebyly uloženy, přesto odejít?" />
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        {item ? (
          <Tabs
            items={[
              {
                label: 'Základní údaje',
                content: <JobsFormBasic change={change} />
              },
              {
                label: 'Spuštení',
                content: <JobRunsGrid item={item} />
              }
            ]}
          />
        ) : (
          <JobsFormBasic change={change} />
        )}
        <Divider />

        <Button label="Uložit a zavřít" primary={true} type="submit" style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const JobsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/jobs/JobsForm.tsx